module.exports = __webpack_public_path__ + "img/compras.cbfce210.svg";